import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { UserRole } from '@faktorplus/shared';
import { useAuth } from './auth-provider';
import { LoadingBlock } from '../components/ui/feedback';

/**
 * Gate for authenticated routes.
 *
 * The attempted path is passed along, so a link from a notification e-mail
 * lands on the invoice after login rather than dumping the user on the home
 * screen to find it themselves.
 */
export function ProtectedRoute({
  allowedRoles,
  children,
}: {
  allowedRoles?: UserRole[];
  children: ReactNode;
}) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingBlock />;

  if (!user) {
    return <Navigate to="/logowanie" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
